import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class TransactioncodewiseTransactionService {
  private baseApiUrl: string;


  constructor (configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
}

getFiltered(filter: string, pageIndex: number, pageSize: number,
  sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

  const params = {
    filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
  };

  return this.httpClient.post(this.baseApiUrl + 'interfacetransactiontypechargesmapping/filter', params).pipe(
    map((res: any) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
}

getAll(forMaintenance: boolean = false): Observable<any> {
   return this.httpClient.get(this.baseApiUrl + `interfacetransactiontypechargesmapping?isMaintenance=${forMaintenance}`).pipe(
    map((res: any) =>  res),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
}

getById(id: number, forMaintenance: boolean = false): Observable<any> {
  return this.httpClient.get(this.baseApiUrl + `interfacetransactiontypechargesmapping/${id}?isMaintenance=${forMaintenance}`).pipe(
    map((res: Response) => this.addLedgerDisplayData(res)),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
}

getByCode(code: string): Observable<any> {
  return this.httpClient.get(this.baseApiUrl + `interfacetransactiontypechargesmapping/code/${code}`).pipe(
    map((res: Response) => this.addLedgerDisplayData(res)),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
}

getByChargesId(moduleId: number):  Observable<any> {
  return this.httpClient.get(this.baseApiUrl + `interfacetransactiontypechargesmapping/application/${moduleId}`).pipe(
    map((res: Response) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
}

create(interfacetransactiontypechargesmapping: any): Observable<any> {
  return this.httpClient.post(this.baseApiUrl + `interfacetransactiontypechargesmapping`, interfacetransactiontypechargesmapping).pipe(
    map((res: Response) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
}

update(interfacetransactiontypechargesmapping: any): Observable<any> {
  return this.httpClient.put(this.baseApiUrl + `interfacetransactiontypechargesmapping`, interfacetransactiontypechargesmapping).pipe(
  map((res: Response) => res),
  catchError((err: any) => observableThrowError(err.message || 'Server error')));
}

authorise(id: number): Observable<any> {
  return this.httpClient.post(this.baseApiUrl + `interfacetransactiontypechargesmapping/authorise`, id).pipe(
    map((res: Response) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
}

delete(id: number): Observable<any> {
  return this.httpClient.delete(this.baseApiUrl + `interfacetransactiontypechargesmapping/${id}`).pipe(
    map((res: Response) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
}

addLedgerDisplayData(ledger: any): any {
  ledger.displayData = `${ledger.description} - ${ledger.code}`;
return ledger;
}

getByCombination(transactionType: number, currency: number, sourceChannelId: number): Observable<any> {
  const url = `${this.baseApiUrl}interfacetransactiontypechargesmapping/getCombinationData/${transactionType}?currency=${currency}&sourceChannelId=${sourceChannelId}`;

  return this.httpClient.get(url).pipe(
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
}


}
